import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import ContentWrapper from '../components/contentwrapper/ContentWrapper'
import { AiFillMobile, AiTwotoneMail } from 'react-icons/ai'
import { toast } from 'react-toastify'
import { addHrRegistration } from '../utils/api'
import { useNavigate } from 'react-router-dom'
import { FaUserTie } from 'react-icons/fa6'

const AddHr = () => {
    const navigate = useNavigate();
    const [values, setUserValue] = useState();

    const handleInputs = e => {
        setUserValue({
            ...values,
            [e.target.name]: e.target.value,
        });
    };
    const handleHrRegistration = async (e) =>{
        e.preventDefault();
        if(values){
            try{
                addHrRegistration('super-admin-add-hr',values).then((res)=>{
                    if(res.data.status===1){
                        toast.success("HR has been added successfully!");
                        navigate('/hr');
                    }
                    else if(res.data.status===2){
                        toast.warning("This HR already exit!!");
                    }
                    else{
                        toast.error("Something Wrongs!!");
                    }
                })
            }
            catch (error) {
                toast.error("Something is worng!!");
            }
        }
        else{
            toast.error("Server internal error!!");
        }
    }
    return (
        <div className="addHrPanel">
            <Helmet>
                <title>SATKARTAR:ADMIN::Add HR</title>
            </Helmet>

            <ContentWrapper>
                <div className="col-xl-6">
                    <div className="card border-top border-0 border-4 border-danger">
                        <div className="card-body">
                            <div className="card-title d-flex align-items-center">
                                <div>
                                    <FaUserTie className="formIcons" />
                                </div>
                                <h5 className="mb-0 text-danger">ADD HR</h5>
                            </div>
                            <hr />
                            <form className="row g-3" onSubmit={handleHrRegistration} method="post">
                                <div className="col-12">
                                    <label htmlFor="hr_name" className="form-label">Name</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-transparent">
                                            <FaUserTie />
                                        </span>
                                        <input type="text" className="form-control border-start-0" id="hr_name" name="hr_name" placeholder="Full Name" onChange={handleInputs} required={true} />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="hr_mobile" className="form-label">Mobile No</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-transparent">
                                            <AiFillMobile />
                                        </span>
                                        <input type="text" className="form-control border-start-0" id="hr_mobile" name="hr_mobile" placeholder="Mobile No" onChange={handleInputs} required={true} />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <label htmlFor="hr_email" className="form-label">Email Address</label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-transparent">
                                            <AiTwotoneMail />
                                        </span>
                                        <input type="email" className="form-control border-start-0" id="hr_email" name="hr_email" placeholder="Email Address" onChange={handleInputs} required={true} />
                                    </div>
                                </div>
                                <div className="col-12">
                                    <button type="submit" className="btn btn-danger px-5">Register</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default AddHr